import {Keycode} from '../constants';

export const initSelect = () => {
	const selects = document.querySelectorAll( 'div.multiselect, div.select' );

	if ( !selects )
	{
		return;
	}

	const updateSelect = ( it, evt ) => {
		const optionsDisplay = it.querySelector( 'span.value' );
		const additionalOptionsDisplay = it.querySelector( 'span.plus' );
		const chosenOptions = Array.from( it.querySelectorAll( 'input[name*="[]"]:checked' ) );
		let optionToShow;

		optionsDisplay.innerHTML = '';
		additionalOptionsDisplay.innerHTML = '';

		if ( evt && evt.target.checked )
		{
			optionToShow = document.querySelector( 'label[for="' + evt.target.id + '"]' ).innerHTML;
		}
		else
		{
			optionToShow = chosenOptions.length > 0 ? chosenOptions[0].nextElementSibling.innerHTML : '';
		}

		switch ( chosenOptions.length )
		{
			case 0:
				optionsDisplay.innerHTML = '';
				break;
			case 1:
				optionsDisplay.innerHTML = optionToShow;

				if ( chosenOptions[0].name === 'sort_select[]' )
				{
					document.querySelector( 'input#' + chosenOptions[0].value ).checked = true;
				}

				break;
			default:
				optionsDisplay.innerHTML = optionToShow;
				additionalOptionsDisplay.innerHTML = chosenOptions.length - 1;
		}

		if ( it.classList.contains( 'select' ) )
		{
			it.querySelector( 'input:not([name*="[]"])' ).checked = false;
		}
	};

	Array.from( selects ).forEach( ( it ) => {
		updateSelect( it );

		it.querySelector( 'ul' ).addEventListener( 'change', ( evt ) => {
			updateSelect( it, evt );
		} );
	} );

	document.addEventListener( 'keyup', ( evt ) => {
		const input = document.querySelector( 'input.select:checked, input.multiselect:checked' );

		if ( evt.keyCode === Keycode.ESC && input )
		{
			input.checked = false;
		}
	} );
};